<template @click="dialog = false">
  <div>
    <v-row v-if="tempMediaOnIndexDB.videoTitle!=''">
      <v-col align="left" cols="12" class="px-7 mb-0 pb-0">
        {{$t('uploadedVideo')}}
      </v-col>
      <v-col align="left" cols="12" class="px-8">
        <v-container class="chipStyle text-left mx-2 mt-0 mb-1 pb-0 pt-0">
          <v-row align="center">
            <v-col cols="1" v-if="tempMediaOnIndexDB.videoTitle">
              <v-icon color="primary" class="mr-1">mdi-video</v-icon>
            </v-col>
            <v-col cols="8" class="text-truncate">
              {{tempMediaOnIndexDB.videoTitle}}
            </v-col>
            <v-col cols="1">
              <i @click="removeVideo()" class=" mdi mdi-close red--text darken-4"></i>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>


    <!--v-row v-if="typeof tempMediaOnIndexDB.images =='object'&&tempMediaOnIndexDB.images.length>0">
      <v-col align="left" cols="12" class="px-7 pb-0">
        {{$t('uploadedImages')}}
      </v-col>
      <v-col align="left" cols="12" class="px-8">
        <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.images" :key="singleFile.id" class="mx-2">
          <template class="text-truncate" v-if="singleFile.id">
            <v-container class="chipStyle text-left mx-2 mt-0 mb-1 pb-0 pt-0">
              <v-row align="center">
                <v-col cols=1>
                  <v-icon color="primary" class="mr-1">mdi-camera-plus-outline</v-icon>
                </v-col>
                <v-col cols="8" class="text-truncate">
                  {{singleFile.title}}
                </v-col>
                <v-col cols=1>
                  <i @click="removeImages(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template class="text-truncate" v-else>
            <v-container class="chipStyle text-left mx-2 mt-0 mb-1 pb-0 pt-0">
              <v-row align="center">
                <v-col cols=1>
                  <v-icon color="primary" class="mr-1">mdi-camera-plus-outline</v-icon>
                </v-col>
                <v-col cols="8" class="text-truncate">
                  {{singleFile.title}}
                </v-col>
                <v-col cols=1>
                  <i @click="removeImages(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-row>
      </v-col>
    </v-row-->






    <v-row v-if="typeof tempMediaOnIndexDB.audios =='object'&&tempMediaOnIndexDB.audios.length>0">
      <v-col align="left" cols="12" class="px-7 pb-0">
        {{$t('uploadedAudio')}}
      </v-col>
      <v-col align="left" cols="12" class="px-8">
        <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.audios" :key="singleFile.id" class="mx-2">
          <template class="text-truncate" v-if="singleFile.id">
            <v-container class="chipStyle text-left mx-2 mt-0 mb-1 pb-0 pt-0">
              <v-row align="center">
                <v-col cols=1>
                  <v-icon color="primary" class="mr-1">mdi-music-note-outline</v-icon>
                </v-col>
                <v-col cols="8" class="text-truncate">
                  {{singleFile.title}}
                </v-col>
                <v-col cols=1>
                  <i @click="removeAudio(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template class="text-truncate" v-else>
            <v-container class="chipStyle text-left mx-2 mt-0 mb-1 pb-0 pt-0">
              <v-row align="center">
                <v-col cols=1>
                  <v-icon color="primary" class="mr-1">mdi-music-note-outline</v-icon>
                </v-col>
                <v-col cols="8" class="text-truncate">
                  {{singleFile.title}}
                </v-col>
                <v-col cols=1>
                  <i @click="removeAudio(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.attachments" :key="singleFile.id"
      class="px-8 mt-0 mb-0 mb-0 pb-0">
      <v-col v-if="i==0" align="left" cols="12" class="px-0">
        {{$t('uploadedAttachment')}}
      </v-col>
      <v-col align="left" class="text-truncate mt-0 mb-0 pt-0 pb-0" v-if="singleFile.id">
        <v-container class="chipStyle text-left">
          <v-row align="center">
            <v-col cols=1>
              <v-icon color="primary" class="mr-1">mdi-attachment</v-icon>
            </v-col>
            <v-col cols="8" class="text-truncate">
              {{singleFile.title}}
            </v-col>
            <v-col cols=1>
              <i @click="removeAttachment(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
            </v-col>
          </v-row>
        </v-container>

      </v-col>
      <v-col align="left" class="text-truncate mt-0 mb-0 pt-0 pb-0" v-else cols=12>
        <v-container class="chipStyle text-left">
          <v-row align="center">
            <v-col cols=1>
              <v-icon color="primary" class="mr-1">mdi-attachment</v-icon>
            </v-col>
            <v-col cols="8" class="text-truncate">
              {{singleFile.title}}
            </v-col>
            <v-col cols=1>
              <i @click="removeAttachment(i)" class=" ml-2 mdi mdi-close red--text darken-4"></i>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent width="300">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col cols="12">
            <v-btn text-capitalize class="floatingBtn text-capitalize" medium color="primaryVariant" v-on="on">
              <i class=" mdi mdi-upload"></i> <span>{{ $t("uploadMedia") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <v-card>
        <v-container>
          <v-row align="center" justify="space-around">
            <v-col :class="'text-center darken-4 uploadLabel '+ classObjectATTACHMENTS" cols=4>
              {{$t('upload_attachment')}}
            </v-col>
            <v-col :class="'text-center darken-4 uploadLabel '+ classObjectVIDEO" cols=4>
              {{$t('upload_video')}}
            </v-col>
          </v-row>

          <v-row align="center" justify="space-around">
            <v-col class="text-center mt-0 pt-0" cols=2>
              <v-file-input multiple id="attachmentFilesUpload" ref="uploadAttachment" class="mt-0 pt-0"
                :prepend-icon="'mdi-attachment darken-4 '+ classObjectATTACHMENTS" accept="*" hide-input
                v-model="attachmentBlob" @change="updateAttachmentBlob"></v-file-input>
            </v-col>
            <v-col class="text-center mt-0 pt-0" cols=2>
              <v-file-input id="videoFileUpload" ref="uploadVideo" class="mt-0 pt-0"
                :prepend-icon="'mdi-video darken-4 '+ classObjectVIDEO" accept="video/*" hide-input
                v-model="videoBlob.file" @change="updateVideoBlob"></v-file-input>
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around">
            <v-col :class="'text-center darken-4 uploadLabel '+ classObjectIMAGES" cols=4>
              {{$t('upload_images')}}
            </v-col>
            <v-col :class="'text-center darken-4 uploadLabel '+ classObjectAUDIO" cols=4>
              {{$t('upload_audio')}}
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around">

            <v-col class="text-center mt-0 pt-0" cols=2>
              <v-file-input multiple id="imageFilesUpload" ref="uploaImage" class="mt-0 pt-0"
                :prepend-icon="'mdi-camera-plus-outline darken-4 '+ classObjectIMAGES" accept="image/*" hide-input
                v-model="imagesBlob" @change="updateImagesBlob"></v-file-input>
            </v-col>

            <v-col class="text-center mt-0 pt-0" cols=2>
              <v-file-input multiple id="audioFilesUpload" ref="uploadAudio" class="mt-0 pt-0"
                :prepend-icon="'mdi-music-note-outline darken-4 '+ classObjectAUDIO" accept="audio/*" hide-input
                v-model="audioBlob" @change="updateAudioBlob"></v-file-input>
            </v-col>
          </v-row>

          <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.attachments" :key="singleFile.id" align="center"
            justify="center">
            <template v-if="singleFile.id">
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-attachment</v-icon> {{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeAttachment(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-attachment</v-icon>{{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeAttachment(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
          </v-row>

          <v-row v-if="tempMediaOnIndexDB.videoTitle!=''" align="center" justify="center">
            <v-col class="text-left text-truncate" cols=10>
              <span v-if="tempMediaOnIndexDB.videoTitle">
                <v-icon color="primary" class="mr-1">mdi-video</v-icon>{{tempMediaOnIndexDB.videoTitle}}
              </span>
            </v-col>
            <v-col align="center" cols=2>
              <div @click="removeVideo()"><i class=" mdi mdi-close red--text darken-4"></i></div>
            </v-col>
          </v-row>

          <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.images" :key="singleFile.id" align="center"
            justify="center">
            <template v-if="singleFile.id">
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-camera-plus-outline</v-icon> {{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeImages(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-camera-plus-outline</v-icon>{{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeImages(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
          </v-row>


          <v-row v-for="(singleFile,i) in tempMediaOnIndexDB.audios" :key="singleFile.id" align="center"
            justify="center">
            <template v-if="singleFile.id">
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-music-note-outline</v-icon> {{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeAudio(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col class="text-left text-truncate" cols=10>
                <v-icon class="mr-1" color="primary">mdi-music-note-outline</v-icon>{{singleFile.title}}
              </v-col>
              <v-col align="center" cols=2>
                <v-btn icon @click="removeAudio(i)"><i class="mdi mdi-close red--text darken-4"></i></v-btn>
              </v-col>
            </template>
          </v-row>
          <v-card-actions>
            <v-btn color="primary" @click="internaldialog=false" text>{{$t("close")}}</v-btn>
            <v-spacer />
            <v-btn @click="saveCurrentStoryMedia()" color="primary" text>{{$t("save")}}</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default ({
  name: "uploadMedia",
  data: () => ({
    imageBlob:{},
    audioTitle:[],
    imageTitle:[],
    audioBlob:[],
    imagesTitle:[],
    imagesBlob:[],
    attachmentBlob:[],
    videoBlob:{},
    internaldialog: false,
    /*maximum FILE uplodable size KB*/
    //2MB
    maxImgFileSize:   1000000,
    //
    maxAudioFileSize: 5000000,
    
    maxImagesFileSize: 1000000,
    //150MB
    maxVideoFileSize: 15000000,
    //attachment
    maxAttachmentFileSize: 5000000,
  }),
  watch:{
    '$store.state.newStories': function() {
    this.cache=this.$store.state.newStories
   }
  },
  async mounted() {
    // check this.tempMediaOnIndexDB  if present, it loads all media into the cache file
    //Read from this.tempMediaOnIndexDB image audio and video

    if (this.tempMediaOnIndexDB.imageTitle!=null&&this.tempMediaOnIndexDB.imageTitle!=""){
      await this.getFileFromIndexDB(this.tempMediaOnIndexDB.imageTitle).then(response=>{
      this.imageBlob.file=response[0].blob
      this.imageBlob.name=this.tempMediaOnIndexDB.imageTitle
      this.imageBlob.lastModified=new Date();
      })
    }

    if (this.tempMediaOnIndexDB.videoTitle!=null&&this.tempMediaOnIndexDB.videoTitle!=""){
      await this.getFileFromIndexDB(this.tempMediaOnIndexDB.videoTitle).then(response=>{
      this.videoBlob.file=response[0].blob
      this.videoBlob.name=this.tempMediaOnIndexDB.videoTitle
      this.videoBlob.lastModified=new Date();
      })
    }

if (this.tempMediaOnIndexDB.audios.length>0){
    for (const element of this.tempMediaOnIndexDB.audios){
      await this.getFileFromIndexDB(element.title).then(response=>{
      this.audioBlob.push(response[0].blob)
      this.audioBlob.name=element.title
      })
    }
  }
  if (this.tempMediaOnIndexDB.images.length>0){
    for (const element of this.tempMediaOnIndexDB.images){
      await this.getFileFromIndexDB(element.title).then(response=>{
      this.imagesBlob.push(response[0].blob)
      this.imagesBlob.name=element.title
      })
    }
  }

  if (this.tempMediaOnIndexDB.attachments.length>0){
    for (const element of this.tempMediaOnIndexDB.attachments){
      await this.getFileFromIndexDB(element.title).then(response=>{
      this.attachmentBlob.push(response[0].blob)
      this.attachmentBlob.name=element.title
      })
    }
  }
    //read from indexed db and set ther value in cache
    this.$store.dispatch("setNewStories", this.cache)
    this.cache=this.$store.state.newStories
  },
  computed: {
//it contains all the information while writing or editing a story
    cache: {
		get: function() {
      return this.$store.state.newStories
		},
		set: function(newValue) {
      this.$store.dispatch("setNewStories", newValue)
		}
  },
//contains the information of the names and sizes on media loaded in the browser while editing a story
  tempMediaOnIndexDB: {
    get: function() {
      return this.$store.state.tempMediaOnIndexDB
		},
		set: function(newValue) {
      this.$store.dispatch("setTempMediaOnIndexDB", newValue)
		}
  },
//Boolean variable that indicates the open / close status of the upload component window
    dialog:{
      cache:false,
      set(value){
        if( value == 0 ){
        this.internaldialog= false
        }
        else{
          this.internaldialog = true
        }
        },
      get(){
        return this.internaldialog
      },
    },
//check if there is an uploaded image and color the image icon blue to indicate the already uploaded image
    classObjectATTACHMENTS: function() {
      if (this.tempMediaOnIndexDB.attachments.length > 0)
        return 'blue--text'
        else
        return ''
    },
//check if there is an uploaded video and color the video icon blue to indicate the already uploaded video
    classObjectVIDEO: function() {
      if (this.tempMediaOnIndexDB.videoTitle!="")
        return 'blue--text'
        else
        return ''
    },
//check if there is an uploaded audio and color the audio icon blue to indicate the already uploaded audio
    classObjectAUDIO: function() {
      if (this.tempMediaOnIndexDB.audios.length > 0)
        return 'blue--text'
        else
        return ''
    },
    //check if there is an uploaded images and color the images icon blue to indicate the already uploaded images
    classObjectIMAGES: function() {
      if (this.tempMediaOnIndexDB.images.length > 0)
        return 'blue--text'
        else
        return ''
    }
  },
  methods: {
    //if an images is loaded it updates the data on indexdb and on vuex. so dda keep it saved even when reloading the page / or changing the page
    updateImageBlob:function(){
      this.dialog=false
      //SAVE ON INDEXED DB
        var imageFileUpload = document.getElementById("imageFileUpload");
        if (typeof (imageFileUpload.files) != "undefined") {
            var size = parseFloat(imageFileUpload.files[0].size / 1024).toFixed(2);

            if (this.maxImgFileSize>size){
              this.$store.dispatch("setDialogPreUpload", {color:'error',active:true,text:imageFileUpload.files[0].name + + '<br><br>' + this.$i18n.t('maxImgSizeText') + Math.round(this.maxImgFileSize/(1024*1024)) + 'MB',isSuccess:false})
              //alert("The image is too large, use files smaller than " + this.maxImgFileSize + " KB.\n"+ "The file size is "+size);
            }else{
            //add the file
            //alert(size + " KB.");
            this.$indexdb.mediaFiles.add({name:imageFileUpload.files[0].name,type:imageFileUpload.files[0].type,mediatype:'image',blob:imageFileUpload.files[0],size:imageFileUpload.files[0].size})
            //update vuex variable
            this.$store.dispatch("addImageTitleOntempMediaOnIndexDB", imageFileUpload.files[0].name)
            this.$store.dispatch("addImageSizeOntempMediaOnIndexDB", imageFileUpload.files[0].size)
            this.dialog=true
            this.$store.dispatch("setDialogPreUpload", {color:'primaryVariant',active:true,text:imageFileUpload.files[0].name,isSuccess:true})
            }
        }
    },
        //if an video is loaded it updates the data on indexdb and on vuex. so dda keep it saved even when reloading the page / or changing the page

    updateVideoBlob:function(){
      this.dialog=false
      //SAVE ON INDEXED DB
        var videoFileUpload = document.getElementById("videoFileUpload");
        if (typeof (videoFileUpload.files) != "undefined") {
            var size = parseFloat(videoFileUpload.files[0].size / 1024).toFixed(2);
            console.log('VIDEO SIZE',size)
            if (this.maxVideoFileSize<size){
              this.$store.dispatch("setDialogPreUpload", {color:'error',active:true,text:event.target.files[0].name + '<br><br>' + this.$i18n.t('maxVideoSizeText') + Math.round(this.maxVideoFileSize/(1024*1024)) + 'MB',isSuccess:false})
            }else{
            this.$store.dispatch("setDialogPreUpload", {color:'primaryVariant',active:true,text:event.target.files[0].name,isSuccess:true})
            //add the file 
            //alert(size + " KB.");
            this.$indexdb.mediaFiles.add({name:event.target.files[0].name,type:event.target.files[0].type,mediatype:'video',blob:event.target.files[0],size:event.target.files[0].size})
            //update vuex variable
            this.$store.dispatch("addVideoTitleOntempMediaOnIndexDB", event.target.files[0].name)
            this.$store.dispatch("addVideoSizeOntempMediaOnIndexDB", event.target.files[0].size)
            this.dialog=true
            }
        }
    },

    //if an attachement is loaded it updates the data on indexdb and on vuex. so dda keep it saved even when reloading the page / or changing the page
    updateAttachmentBlob:function(){
      this.dialog=false
      this.attachmentBlob.forEach (file => {
        if (file.size<this.maxAttachmentFileSize){
        //  SAVE ON INDEXED DB
        // to exit use return
        this.$indexdb.mediaFiles.add({name:file.name,filetype:file.type,mediatype:'other',blob:file,size:file.size})
        //update vuex variable
        this.$store.dispatch("addAttachmentOntempMediaOnIndexDB", {title:file.name,size:file.size})
        this.$store.dispatch("setDialogPreUpload", {color:'primaryVariant',active:true,text:file.name,isSuccess:true})
        }else 
        this.$store.dispatch("setDialogPreUpload", {color:'error',active:true,text:file.name + '<br><br>' + this.$i18n.t('maxFileSizeText') + Math.round(this.maxAttachmentFileSize/(1024*1024)) + 'MB',isSuccess:false})
        return;
      })
      this.dialog=true
    },
    //if an audio is loaded it updates the data on indexdb and on vuex. so dda keep it saved even when reloading the page / or changing the page
    updateAudioBlob:function(){
      this.dialog=false
      this.$store.dispatch("removeAllAudiosNewStories")
      this.$store.dispatch("removeAllAudioOntempMediaOnIndexDB")
      this.audioBlob.forEach (file => {
        if (file.size<this.maxAudioFileSize){
          //  SAVE ON INDEXED DB
          this.$indexdb.mediaFiles.add({name:file.name,filetype:file.type,mediatype:'audio',blob:file,size:file.size})
          //update vuex variable
          this.$store.dispatch("addAudioOntempMediaOnIndexDB", {title:file.name,size:file.size})
          this.$store.dispatch("setDialogPreUpload", {color:'primaryVariant',active:true,text:file.name,isSuccess:true})
        }else
        {
          this.$store.dispatch("setDialogPreUpload", {color:'error',active:true,text:file.name + '<br><br>' + this.$i18n.t('maxAudioSizeText') + Math.round(this.maxAudioFileSize/(1024*1024)) + 'MB',isSuccess:false})
          return
        }
      })
      this.dialog=true
    },
    //if an images is loaded it updates the data on indexdb and on vuex. so dda keep it saved even when reloading the page / or changing the page
    updateImagesBlob:function(){
      this.dialog=false
      this.$store.dispatch("removeAllImagesNewStories")
      this.$store.dispatch("removeAllImagesOntempMediaOnIndexDB")
      this.imagesBlob.forEach (file => {
        if (file.size<this.maxAudioFileSize){
          //  SAVE ON INDEXED DB
          this.$indexdb.mediaFiles.add({name:file.name,filetype:file.type,mediatype:'image',blob:file,size:file.size})
          //update vuex variable
          this.$store.dispatch("addImagesOntempMediaOnIndexDB", {title:file.name,size:file.size})
          this.$store.dispatch("setDialogPreUpload", {color:'primaryVariant',active:true,text:file.name,isSuccess:true})
        }else
        {
          this.$store.dispatch("setDialogPreUpload", {color:'error',active:true,text:file.name + '<br><br>' + this.$i18n.t('maxImgFileSizeText') + Math.round(this.maxImagesFileSize/(1024*1024)) + 'MB',isSuccess:false})
          return
        }
      })
      this.dialog=true
    },
    //using file name as primary key I recover media files from indexdb
    getFileFromIndexDB: function (name) {
        return this.$indexdb.mediaFiles.where("name").equalsIgnoreCase(name).toArray()
    },
    //save the current draft Story
    saveCurrentStoryMedia: function () {
//the video uploaded with the upload are read and saved in indexed db to allow the preview page to view it without sending them to the backend
      if (this.videoBlob.file){
          this.cache.videoFileRaw=this.videoBlob.file
          var readervideo = new FileReader();
          readervideo.onloadend =  function() {
            //this.$indexdb.mediaFiles.add({name:this.videoBlob.name,filetype:this.videoBlob.type,mediatype:'video',blob:readervideo.result,size:this.videoBlob.size})
            //this.tempMediaOnIndexDB.videoTitle = this.videoBlob.name
            //this.tempMediaOnIndexDB.videoSize = this.videoBlob.size
            //this.$store.dispatch("addVideoTitleOntempMediaOnIndexDB", this.videoBlob.name)
            //this.$store.dispatch("addVideoSizeOntempMediaOnIndexDB", this.videoBlob.size)
          }.bind(this)
          readervideo.readAsArrayBuffer(this.videoBlob.file);
          this.cache.videofileTitle= this.videoBlob.name
      }

//the image loaded with the upload are read and saved in indexed db to allow the preview page to view it without sending them to the backend
      if (this.imageBlob.file){
          var readerimage = new FileReader();
          readerimage.onloadend = function() {
              //this.$indexdb.mediaFiles.add({name:this.imageBlob.name,filetype:this.imageBlob.type,mediatype:'image',blob:readerimage.result,size:this.imageBlob.size})
              //this.tempMediaOnIndexDB.imageTitle = this.imageBlob.name
              //this.tempMediaOnIndexDB.imageSize = this.imageBlob.size
              //this.$store.dispatch("addImageTitleOntempMediaOnIndexDB", this.imageBlob.name)
              //this.$store.dispatch("addImageSizeOntempMediaOnIndexDB", this.imageBlob.size)
        }.bind(this)
          readerimage.readAsArrayBuffer(this.imageBlob.file);
      }

//the audio files loaded with the upload are read and saved in indexed db to allow the preview page to view it without sending them to the backend

/*
      if (this.audioBlob.length!=null){
          this.audioBlob.forEach((element)=>{
            console.log("uploadMedia audio element",element)

            let readeraudio = new FileReader();
            readeraudio.onloadend = async function() {
              await this.$indexdb.mediaFiles.add({name:element.name,filetype:element.type,mediatype:'audio',blob:readeraudio.result,size:element.size})
              this.$store.dispatch("addAudioOntempMediaOnIndexDB", {title:element.name,size:element.size})
            }.bind(this)
            readeraudio.readAsArrayBuffer(element);
          })
      }
*/

//save the current Story in vuex (local storage)
      this.$store.dispatch("setNewStories", this.cache)
      this.dialog=1
      this.dialog=0
    },
//remove attachement saved in cache
//todo configure the store
    removeAttachment(index){
      this.attachmentBlob.splice(index,1)
      this.$store.dispatch("removeAttachmentOntempMediaOnIndexDB", index)
    },
//remove the current video saved in cache
//todo remove video from indexdb
    removeVideo(){
      this.$store.dispatch("addVideoTitleOntempMediaOnIndexDB","")
      this.$store.dispatch("addVideoSizeOntempMediaOnIndexDB",null)
      this.$store.dispatch("addVideoIDOntempMediaOnIndexDB",null)
      this.videoBlob={}

    },
//remove the current Audio saved in cache
//todo remove image from indexdb
    removeAudio(index){
      this.audioBlob.splice(index,1)
      this.$store.dispatch("removeAudioOntempMediaOnIndexDB", index)
    },
    //remove the current Audio saved in cache
//todo remove image from indexdb
    removeImages(index){
      this.imagesBlob.splice(index,1)
      this.$store.dispatch("removeImagesOntempMediaOnIndexDB", index)
    }
  }
})
</script>

<style>
/*style="transform:rotate(270deg)*/
.chipStyle{
  color: #38737A;
  background-color: #e5ffff !important;
  border-color: #e5ffff !important;
  border-radius: 999rem;
  padding: 2%;
  font-size: 0.8rem;
}
.mdi-attachment{
  transform:rotate(270deg)
}
.uploadLabel{
  font-size: 0.9rem;
  font-weight: bold;
  text-transform: capitalize;
  white-space: nowrap;
}
</style>